// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-container[data-v-587b5356] {\n  padding: 24px;\n}\n.icon-container .icon-wrapper[data-v-587b5356] {\n  padding: 15px 0;\n}\n.icon-container .icon-wrapper[data-v-587b5356]:hover {\n  background-color: #1890ff;\n  color: #fff;\n}\n.icon-container .icon-wrapper .disabled[data-v-587b5356] {\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
